import React from "react";

function ErrorMsg({ e, className }) {
	if (e) return <div className={`mt-2 text-sm text-red-500 ${className}`}>{e}</div>;

	return null;
}

export default ErrorMsg;
